import { ReactNode } from 'react';

import style from './sectionTitle.module.scss';

type Props = {
  children: ReactNode;
};

const SectionTitle = ({ children }: Props) => {
  return <h2 className={style.title}>{children}</h2>;
};

export default SectionTitle;
